import { render, staticRenderFns } from "./Mass.vue?vue&type=template&id=048b9d00"
import script from "./Mass.vue?vue&type=script&lang=js"
export * from "./Mass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports